import { Dayjs } from "dayjs";
import { ISODateString } from "../../../types/date";
import { getDayjs } from "../../../helpers/dateHelpers";

// returnByDate computes when a territory checked out on `start` is due back,
// based on the congregation's configured checkout window (in days).
export function returnByDate(start: ISODateString | null, checkoutDurationDays: number): Dayjs {
  // Fall back to 120 days when the setting is missing/0 — mirrors the defaults
  // used elsewhere (return.tsx checkoutCutoff, common.tsx) and prevents an
  // invalid date (which threw "RangeError: Invalid time value").
  return getDayjs(start ?? new Date()).add(checkoutDurationDays || 120, "days");
}
